<template>
	<header>
		<!-- logged in navbar -->
		<div v-if="isloggedin" class="navbar fixed-top navbar-expand-lg navbar-dark bg-primary mb-2 py-0">
			<div class="container-fluid">
				<router-link to="/home" class="navbar-brand">PEI Client Access</router-link>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse" id="navbarResponsive">
					<ul class="navbar-nav ml-auto" id="topnav">
						<li class="nav-item">
							<router-link to="/home" class="nav-link">Home</router-link>
						</li>
						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								{{ $store.state.auth.user.fname }} {{ $store.state.auth.user.lname }}
							</a>
							<div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
								<router-link to="/account" class="dropdown-item">My Account</router-link>
								<router-link v-if="isorgadmin" to="/organization" class="dropdown-item">My Organization</router-link>
								<!-- logout if special, it doesn't go to an actual route -->
								<div class="dropdown-divider"></div>
								<a @click.prevent="logout" href="/logout" class="dropdown-item">Logout</a>
								<!-- <a @click.prevent="logout" href="/logout" class="dropdown-item">Logout ({{ $store.state.auth.user.id }}, {{ $store.state.auth.org.name }})</a> -->
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- logged out navbar -->
		<div v-else class="navbar navbar-expand-lg navbar-dark bg-primary pb-4">
			<div class="container">
				<router-link to='/' class="navbar-brand">PEI Client Access</router-link>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse" id="navbarResponsive">
					<ul class="navbar-nav ml-auto" id="topnav">
						<li :class="['nav-item', { active: $route.name === 'login' }]">
							<router-link to="/login" class="nav-link">Login</router-link>
						</li>
						<li :class="['nav-item', { active: $route.name === 'signup' }]">
							<router-link to="/signup" class="nav-link">Signup</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Navbar',
  computed: {
    ...mapGetters('auth', ['isloggedin', 'isorgadmin'])
  },
  methods: {
    ...mapActions('auth', ['logout'])
  }
}

</script>
